export const SUPPORTED_LOCALES = ['en', 'sv'];
export const DEFAULT_LOCALE = 'en';
export const LOCALE_LABELS = { en: 'English', sv: 'Svenska' };
export const LOCALE_STORAGE_KEY = 'delegon_locale';
